export const FIREBASE_API = {
  apiKey: "AIzaSyDaiurw2JjdTCO-pkUJUwv-DplyxDXpljM",
  authDomain: "star-app-e0302.firebaseapp.com",
  projectId: "star-app-e0302",
  storageBucket: "star-app-e0302.appspot.com",
  messagingSenderId: "310755645543",
  appId: "1:310755645543:web:9b1930c462be9540c75cc2",
};
//Aquí puede evaluar cómo condujo el estudiante. Hay N por Nuevo, R por Repetido, 3 para mal, 4 para suficiente y 5 para bien.
const colors = ["#ae0000", "#cd5757", "#fe6d00", "#dbca02", "#03de00"];

export const genders = [
  {
    label: "Other",
    value: "other",
  },
  {
    label: "Male",
    value: "male",
  },
  {
    label: "Female",
    value: "female",
  },
];
export const ratingTypes = [
  { id: "N", label: "New", color: colors[0] },
  { id: "R", label: "Repeat", color: colors[1] },
  { id: "3", label: "Bad", color: colors[2] },
  { id: "4", label: "Sufficient", color: colors[3] },
  { id: "5", label: "Good", color: colors[4] },
];
export const ratingTypesColors = {
  N: colors[0],
  R: colors[1],
  3: colors[2],
  4: colors[3],
  5: colors[4],
};
export const usersTypes = { student: "student", instructor: "instructor", admin: "admin" };
export const accessTypes = {
  driving: "driving",
  VKU: "VKU",
  firstAid: "firstAid",
  motorcycle: "motorcycle",
};
export const drivingCourseStatusTypes = {
  pending: "pending",
  inProgress: "inProgress",
  completed: "completed",
  canceled: "canceled",
};
export const drivingLessonsStatusList = [
  { id: "waitingPayment", label: "Waiting Payment" },
  { id: "planned", label: "Planned" },
  { id: "completed", label: "Completed" },
  { id: "cancelled", label: "Cancelled" },
];
export const drivingLessonsStatusTypes = {
  waitingPayment: drivingLessonsStatusList[0].id,
  planned: drivingLessonsStatusList[1].id,
  completed: drivingLessonsStatusList[2].id,
  cancelled: drivingLessonsStatusList[3].id,
};
export const billingTypes = {
  buyLesson: "buyLesson",
  redeemLesson: "redeemLesson",
  buyCourse: "buyCourse",
};
export const billingTypeList = [
  { id: billingTypes.buyLesson, label: "Buy Lesson" },
  { id: billingTypes.redeemLesson, label: "Pay Lesson" },
  { id: billingTypes.buyCourse, label: "Buy Course" },
];
export const billingStatusType = {
  pending: "pending",
  inProgress: "inProgress",
  completed: "completed",
  reserved: "reserved",
  settled: "completed",
  canceled: "canceled",
  failed: "failed",
};
